import {onFind} from "@elements/init-modules-in-scope";
import {on, trigger} from "@elements/dom-utils";
import Autocomplete from "../libs/autocomplete";
import axios from "axios";

console.log("Typeahaead");
export function init() {
    onFind('.js-keycard-typeahead', function (baseElement) {
        let pendingRequest;
        let url = baseElement.dataset.keycardTypeaheadUrl;
        let test = new Autocomplete(baseElement, {
            howManyCharacters: 4,
            cache: false,
            insertToInput: false,
            onSearch: ({currentValue}) => {
                const api = `${url}?q=${encodeURI(
                    currentValue
                )}`;

                if(pendingRequest) {
                    pendingRequest.abort();
                }
                pendingRequest = new AbortController();
                return axios({
                    url: api,
                    signal: pendingRequest.signal,
                    headers: {'X-Requested-With': 'XMLHttpRequest'},
                }).then((response) => response.data)
                .then((result) => {
                    return result.data.options;
                })
                .catch((error) => {
                    console.error(error);
                });
            },
            onResults: ({currentValue, matches, template}) => {
                return matches === 0
                    ? template
                    :matches
                    .map(({displayValue, status}) => {
                        // remove spaces from displayValue
                        let newDisplayValue = displayValue.replace(/\s/g, "");
                        if(currentValue.startsWith('0')) {
                            displayValue = newDisplayValue;
                        }
                        return `
                          <li class="">
                            ${displayValue.replace(
                                new RegExp(currentValue, "gi"),
                                (str) => `<b>${str}</b>`
                            )}
                          </li>`;
                    })
                    .join("");
            },
            onSubmit: ({ index, element, object, results }) => {
                if (!object) return;
                element.value = object.number;
                trigger('change', element)
            }
        });

    });
}


